import { render, staticRenderFns } from "./Lottosets.vue?vue&type=template&id=267616f6&scoped=true&"
import script from "./Lottosets.vue?vue&type=script&lang=js&"
export * from "./Lottosets.vue?vue&type=script&lang=js&"
import style0 from "./Lottosets.vue?vue&type=style&index=0&id=267616f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267616f6",
  null
  
)

export default component.exports